export const timeNewGp = "2023/08/31";
